import { HubConnectionBuilder } from '@aspnet/signalr/'
import { addStartHook, removeStartHook, addEndHook, removeEndHook } from '$app/auth/auth-session.js'

function buildConnection() {
  let connection = {};
  let disconnectRequested = false;
  let suspended = false;
  let queueUpdatedFn = (eventArgs) => { };

  function setupConnection() {
    connection = new HubConnectionBuilder().withUrl('processingQueueHub').build();
  }

  async function startConnection() {
    try {
      await connection.start();
    } catch (err) {
      console.log(err);
      setTimeout(() => startConnection(), 10000)
    }
  }

  const suspendConnection = async () => {
    if (connection) {
      suspended = true;
      await connection.stop();
    }
  };

  const resumeConnection = async () => {
    if (connection) {
      suspended = false;
      await startConnection();
    }
  };

  return ({
    onQueueUpdated(fn) { queueUpdatedFn = fn },
    async connect() {
      setupConnection();
      disconnectRequested = false;
      suspended = false;

      connection.on('ProcessingQueuesUpdated', (eventArgs) => {
        if (!suspended) {
          queueUpdatedFn(eventArgs);
        }
      });

      connection.onclose(async () => {
        if (!disconnectRequested && !suspended) {
          await startConnection();
        }
      });

      await startConnection();

      addStartHook(resumeConnection);
      addEndHook(suspendConnection);
    },
    async disconnect() {
      removeStartHook(resumeConnection);
      removeEndHook(suspendConnection);
      if (connection) {
        disconnectRequested = true;
        await connection.off();
        await connection.stop();
        connection = null;
      }
    }
  });
}

export {
  buildConnection
}
